import {
  Button,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalProps,
  Text,
} from '@ritualco/jutsu'
import { HeraModal } from 'components/HeraModal'
import { useContent } from 'lib/content/react'

export type PaymentMethodSwitchModalProps = {
  onSubmit: () => void
} & Omit<ModalProps, 'children'>

export const PaymentMethodSwitchModal = ({
  isOpen,
  onClose,
  onSubmit,
  ...modalProps
}: PaymentMethodSwitchModalProps) => {
  const { formatMessage } = useContent()

  return (
    <HeraModal
      size="sm"
      isOpen={isOpen}
      onClose={onClose}
      isCentered={true}
      {...modalProps}
    >
      <ModalHeader>
        {formatMessage({ id: 'pmportal.billing.switchCardTitle' })}
      </ModalHeader>
      <ModalBody>
        <Text color="grayscale.secondary">
          {formatMessage({ id: 'pmportal.billing.switchCardDescription' })}
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button colorScheme="transparent" mr={2} onClick={onClose}>
          {formatMessage({ id: 'pmportal.global.actionCancel' })}
        </Button>
        <Button
          type="submit"
          onClick={async () => {
            await onSubmit()
            onClose()
          }}
        >
          {formatMessage({ id: 'pmportal.global.actionConfirm' })}
        </Button>
      </ModalFooter>
    </HeraModal>
  )
}
